<template>
  <section class="all_emp card_style">
    <div class="d-flex align-items-center gap-3 mb-2">
      <AddFavDailog v-tooltip.left="$t('add_to_favourite')" />
      <h4 class="mb-0">
        {{ $t("about_us") }}
      </h4>
    </div>
    <div class="main_header_style mb-2">
      <input
        type="text"
        v-model="sectionText"
        @keyup="fetchAboutDetails((page = 1))"
        class="form-control w-50"
        :placeholder="$t('search...')"
      />
      <router-link
        :to="{ name: 'aboutSecondAdd' }"
        class="PrimaryButton mt-0 btn"
        ><i class="fa-solid fa-plus"></i> {{ $t("addCard") }}
      </router-link>
    </div>

    <div class="row">
      <table class="table">
        <thead>
          <tr>
            <th>{{ $t("ID") }}</th>
            <th>{{ $t("Image") }}</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("describtion") }}</th>
            <th>{{ $t("Control") }}</th>
          </tr>
        </thead>

        <tbody v-if="loading" class="text-center">
          <tr v-for="about in 10" :key="about">
            <td>
              <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
            </td>
            <td width="10%">
              <Skeleton shape="circle" size="5rem"></Skeleton>
            </td>
            <td v-for="about in 3" :key="about">
              <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr v-for="(about, index) in about_details.data" :key="index">
            <td>{{ about.id }}</td>
            <td>
              <img :src="about.image" :alt="about.titles" />
            </td>
            <td>{{ about.titles }}</td>
            <td>
              <span v-html="about.description.substring(0, 50) + ' ...'"></span>
            </td>

            <td>
              <router-link
                :to="`/about/${type}/edit/${about.id}`"
                class="btn btn-success mx-1 w-auto"
              >
                <i class="fa-regular fa-pen-to-square"></i>
              </router-link>

              <div
                class="btn btn-danger mx-1 w-auto"
                @click="deleteOpinion(about.id, index)"
              >
                <i class="fa-solid fa-trash"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <pagination
        :data="about_details"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchAboutDetails"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div>
  </section>
</template>

<script>
import AddFavDailog from "@/components/layout/addFavDailog.vue";
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
import Skeleton from "primevue/skeleton";
export default {
  name: "clientOpinion",
  data() {
    return {
      about_details: [],
      sectionText: "",
      loading: true,
      type: this.$route.params.type,
    };
  },
  components: {
    pagination,
    AddFavDailog,
    Skeleton,
  },
  methods: {
    fetchAboutDetails(page = 1) {
      const formData = new FormData();
      formData.append("word", this.sectionText);
      if (this.$route.params.type === "portal") {
        formData.append("is_portal", 1);
      }
      axios
        .post(`/fetch_about_details?page=${page}`, formData)
        .then(({ data }) => {
          this.about_details = data.data;
          // console.log(this.about_details.data, "www");

          this.loading = false;
        });
    },
    deleteOpinion(opinionId, index) {
      Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          const fromClick = true;
          axios
            .delete(`/website/delete_about_details/${opinionId}`, { fromClick })
            .then(({ data }) => {
              if (data.status == true) {
                Swal.fire("", data.message, "success");
                this.about_details.data.splice(index, 1); // Remove the deleted item from the array
              } else {
                Swal.fire("", data.message, "error");
              }
            });
        }
      });
    },
  },

  created() {
    this.fetchAboutDetails();

    localStorage.removeItem("flightData");
    localStorage.removeItem("flightTrips");
    localStorage.removeItem("bookDataFlight");
    localStorage.removeItem("bookDetails");
    localStorage.removeItem("hotelData");
    localStorage.removeItem("bookData");
  },
};
</script>

<style></style>
